import React, { useContext } from "react"
import { useFormContext } from "react-hook-form"

import Divider from "src/components/Divider"
import Form from "src/components/Form"

import { VALIDATED_FIELDS_BY_TAB } from "../../../constants"
import { ContractsFormContext } from "../../ContractsFormContext"
import LateFeeSettings from "../../shared/LateFeeSettings"
import PageActions from "../../wizard/PageActions"
import AddOnItems from "./AddOnItems"

const AddItems = () => {
  const { useNewTaxExperience } = useContext(ContractsFormContext)
  const {
    formState: { errors },
    trigger,
  } = useFormContext()

  return (
    <>
      <div className="flex flex-col gap-4">
        <h2 className="my-0 text-sm font-semibold">Late Fee</h2>
        <LateFeeSettings useNewTaxExperience={useNewTaxExperience} />
        {errors?.lateFeeSettings ? (
          <Form.Error>
            Late fee configuration is invalid, please contact mayday@dockwa.com
            for assistance.
          </Form.Error>
        ) : null}
        <Divider />
        <h2 className="my-0 text-sm font-semibold">Items</h2>
        <AddOnItems />
      </div>
      <PageActions
        pageValidation={() => trigger(VALIDATED_FIELDS_BY_TAB.addItems)}
      />
    </>
  )
}

export default AddItems
